import { useState } from 'react';
import { useT } from '@hana/i18n';
import './screens.i18n';
import { IconArrowBackUp, IconDeviceFloppy } from '@tabler/icons-react';
import { Button, Segmented, useToast } from '@hana/ui';
import { TITLES, jdFor, levelsOf, type JdText } from './orgCatalog';
import s from './hr.module.css';

// Mint-HR · tab Cơ cấu & ghế › JD (code board khối `orgJd`). Nháp giữ trong màn; Lưu báo toast (không ghi DB).

export function HrOrgJd() {
  const t = useT();
  const toast = useToast();
  const [code, setCode] = useState('OPS-DOC');
  const [lvPick, setLvPick] = useState('L02');
  const [draft, setDraft] = useState<(JdText & { key: string }) | null>(null);
  const ti = TITLES.find((x) => x[0] === code) ?? TITLES[0]!;
  const lvs = levelsOf(ti);
  const lv = lvs.includes(lvPick) ? lvPick : lvs[0]!;
  const key = `${ti[0]}-${lv}`;
  const base = jdFor(ti, lv);
  const cur = draft && draft.key === key ? draft : null;
  const val = cur ?? base;
  const set = (f: keyof JdText) => (v: string) => setDraft({ ...val, key, [f]: v });
  const fields: ReadonlyArray<readonly [keyof JdText, string, number]> = [['a', 'Mục đích công việc', 2], ['b', 'Nhiệm vụ (mỗi dòng một ý)', 5], ['c', `Yêu cầu theo bậc ${lv}`, 4]];
  return (
    <section className={`${s.card} ${s.jd}`} aria-label="Mô tả công việc">
      <div className={s.jdTop}>
        <label className={s.jdTitle}>
          <div>{t('hr.s.title')}</div>
          <select aria-label="Chức danh JD" value={ti[0]} onChange={(e) => setCode(e.target.value)}>
            {TITLES.map((x) => <option key={x[0]} value={x[0]}>{x[0]} · {x[1]}</option>)}
          </select>
        </label>
        <div>
          <div className={s.jdLbl}>{t('hr.s.grade')}</div>
          <Segmented kind="toggle" label="Bậc JD" value={lv} onChange={setLvPick} items={lvs.map((c) => ({ key: c, label: c }))} />
        </div>
        <span className={s.jdVer}>{t('hr.s.jdVer')}</span>
      </div>
      {fields.map(([f, k, rows]) => (
        <label key={f} className={s.jdField}>
          <div>{k}</div>
          <textarea aria-label={k} rows={rows} value={val[f]} onChange={(e) => set(f)(e.target.value)} />
        </label>
      ))}
      <div className={s.jdFoot}>
        <span>{cur ? 'Có thay đổi chưa lưu' : 'JD dùng cho hồ sơ nhân viên, tin tuyển dụng và đánh giá thử việc'}</span>
        <span className={s.grow} />
        <Button variant="ghost" icon={<IconArrowBackUp size={16} aria-hidden="true" />} onClick={() => setDraft(null)}>{t('hr.s.discard')}</Button>
        <Button variant="primary" className={cur ? undefined : s.jdSaveOff} icon={<IconDeviceFloppy size={16} aria-hidden="true" />} onClick={() => toast({ msg: t('hr.s.noWrite') })}>{t('hr.s.saveJd')}</Button>
      </div>
    </section>
  );
}
